import React, { useEffect, useState } from 'react'
import { Tag } from 'redux/tags/tagsTypes'
import CommutersTable from '../MyCommuters/CommutersTable'
import SegmentsDrawer from '../components/SegmentsDrawer'
import Loading from 'core-system/Loading'
import { useSelector, useDispatch } from 'react-redux'
import { AppState } from 'redux/config/store'
import { employeeActions } from 'redux/employee/employeeSlice'
import SecondaryButton from 'core-system/Button/SecondaryButton'

interface TagInfoDrawerProps {
  open: boolean
  closeModal: () => void
  tag: Tag
  commutersAddMode?: boolean
}

const TagInfoDrawer = (props: TagInfoDrawerProps) => {
  const dispatch = useDispatch()
  const { open, closeModal, tag, commutersAddMode = false } = props

  const [isAdd, setIsAdd] = useState(commutersAddMode)
  const [isEdit, setIsEdit] = useState(false)

  const { myCommuters } = useSelector((state: AppState) => state.employee)
  const { segmentsType, allEmployeeSegmentId } = useSelector(
    (state: AppState) => state.employer
  )
  const { tagsMap } = useSelector((state: AppState) => state.tags)

  const activeTag = tagsMap?.[tag.id] ?? tag

  useEffect(() => {
    setIsAdd(commutersAddMode)
  }, [commutersAddMode])

  const allCommuters =
    myCommuters && segmentsType
      ? myCommuters[allEmployeeSegmentId] || myCommuters[segmentsType.all[0].id]
      : null

  useEffect(() => {
    if (!allCommuters && allEmployeeSegmentId) {
      dispatch(
        employeeActions.getMyCommuters({
          segment: allEmployeeSegmentId,
        })
      )
    }
  }, [allCommuters, allEmployeeSegmentId, dispatch])

  if (!myCommuters || !segmentsType || !allCommuters) {
    return <Loading fullPage />
  }

  const tagCommuters = allCommuters.filter((commuter) =>
    commuter.tagsEnrolled?.includes(activeTag.id)
  )

  const getActiveCommuters = () => {
    if (isAdd) {
      return tagCommuters
    }
    return []
  }

  return (
    <SegmentsDrawer
      title='Tag Details'
      open={open}
      onCloseModal={closeModal}
      titleRightComponent={
        <>
          <SecondaryButton
            onClick={() => setIsAdd(true)}
            disabled={isAdd || isEdit}
          >
            Add Commuters
          </SecondaryButton>
          <SecondaryButton
            onClick={() => setIsEdit(true)}
            disabled={isEdit || isAdd}
          >
            Manage Commuters
          </SecondaryButton>
        </>
      }
    >
      <CommutersTable
        myCommuters={isAdd ? allCommuters : tagCommuters}
        activeCommuters={getActiveCommuters()}
        activeSegment={null}
        activeTag={activeTag}
        tagMode
        isEdit={isEdit}
        isAdd={isAdd}
        setIsEdit={setIsEdit}
        setIsAdd={setIsAdd}
      />
    </SegmentsDrawer>
  )
}

export default TagInfoDrawer
